import SimpleLogin from "../components/auth/SimpleLogin";

const Login = () => {
    return <SimpleLogin />;
};

export default Login;
